export function ensureConversationId(key = "icieos_chat_cid") {
  if (typeof window === "undefined") return "cid-server";
  let cid = localStorage.getItem(key);
  if (!cid) {
    // crypto.randomUUID may not exist in older runtimes; fallback to simple uid
    cid =
      (crypto && crypto.randomUUID && crypto.randomUUID()) ||
      Date.now().toString(36) + Math.random().toString(36).slice(2);
    localStorage.setItem(key, cid);
  }
  return cid;
}

export async function sendMessageToChatAPI(message, cid) {
  const url = "/api/chat";
  const body = JSON.stringify({
    conversation_id: cid ?? ensureConversationId(),
    message,
  });

  const res = await fetch(url, {
    method: "POST",
    headers: { "Content-Type": "application/json" },
    body,
  });

  if (!res.ok) {
    throw new Error(`Chat API ${res.status}`);
  }

  const payload = await res.json();
  const data =
    payload && typeof payload === "object"
      ? (payload.data ?? payload)
      : payload;
  const text = (
    data?.response ??
    data?.message ??
    data?.result ??
    ""
  ).toString();
  return text;
}
